import { ExternalChatChannelsQuery_externalChatChannels } from "graphql/Chats/apollo-graphql-generated/ExternalChatChannelsQuery"
import User from "graphql/User/User"
import castArray from "lodash/castArray"
import { reportToBugsnag } from 'utils/reportToBugsnag'
import { prettifyPhoneString } from "./phoneNumberConversion"

export const getExternalChatChannelIdsArray = (externalChatChannelIds: string | string[]) => {
  const externalChatChannelIdsArray = externalChatChannelIds && castArray(externalChatChannelIds)
  const externalChatChannelIdsArray2: string[] = []

  // check for any string is that has ',' inside. Split into multiple ids.
  for (const id of externalChatChannelIdsArray || []) {
    if (id.includes(',')) {
      const ids = id.split(',').filter(cur => !!cur)
      externalChatChannelIdsArray2.push(...ids)
    } else {
      externalChatChannelIdsArray2.push(id)
    }
  }

  return externalChatChannelIdsArray2;
}

type ChatOnlineUrlParams = {
  clientId?: string,
  clientName?: string,
  clientPhone?: string,
  clientMessage?: string,
  clientBusinessType?: string,
  clientSecret?: string,
  showMessagesOnly: string,
}
export const parseChatOnlineUrlParams = (params: URLSearchParams, user?: User): ChatOnlineUrlParams => {
  let clientId: string = null
  let clientName: string = null
  let clientPhone: string = null
  let clientMessage: string = null
  let clientBusinessType: string = null
  let clientSecret: string = null
  let showMessagesOnly: string = null

  const optionsBase64 = params.get('options');
  if (optionsBase64) {
    // if there is an 'options' param,
    // decode options string from base64
    const jsonStr = atob(optionsBase64)
    if (jsonStr) {
      try {
        const jsonObj: ChatOnlineUrlParams = JSON.parse(jsonStr)
        if (jsonObj) {
          clientId = jsonObj.clientId
          clientName = jsonObj.clientName
          clientPhone = jsonObj.clientPhone
          clientMessage = jsonObj.clientMessage
          clientBusinessType = jsonObj.clientBusinessType
          clientSecret = jsonObj.clientSecret
          showMessagesOnly = jsonObj.showMessagesOnly
        }
      } catch (e: any) {
        reportToBugsnag({ error: e, user, caller: 'parse optionsBase64' });
        console.log(`[ChatOnlinePage] Error while parsing json string from url 'options' param`)
        console.log(e)
      }
    }
  } else {
    // get options directly from the url params
    clientId = params.get('clientId');
    clientName = params.get('clientName');
    clientPhone = params.get('clientPhone');
    clientMessage = params.get('clientMessage');
    clientBusinessType = params.get('clientBusinessType');
    clientSecret = params.get('clientSecret');
    showMessagesOnly = params.get('showMessagesOnly');
  }

  return { clientId, clientName, clientPhone, clientMessage, clientBusinessType, clientSecret, showMessagesOnly }
}

type ClientUrlParams = {
  id?: string,
  secret?: string,
}
export const parseClientUrlParams = (params: URLSearchParams): ClientUrlParams => {
  let id: string = null
  let secret: string = null

  const optionsBase64 = params.get('options');
  if (!optionsBase64)
    return {}

  const jsonStr = atob(optionsBase64)
  if (jsonStr) {
    try {
      const jsonObj: ClientUrlParams = JSON.parse(jsonStr)
      if (jsonObj) {
        id = jsonObj.id
        secret = jsonObj.secret
      }
    } catch (e: any) {
      console.log(e)
    }
  }

  return { id, secret };
}

export const getChannelNameWithAgency = (externalChatChannel: ExternalChatChannelsQuery_externalChatChannels, user: User): string => {
  const agencyChild = user?.getAgencyChildByExternalChatChannelId(externalChatChannel.id) || user?.getAgencyChildByWidgetId(externalChatChannel.id);
  const idInChannelPretty = prettifyPhoneString(externalChatChannel?.idInChannel);
  const channelName = externalChatChannel?.isInternalUserChat ? "Chat Interno" : externalChatChannel?.name;

  return [agencyChild?.name, channelName, idInChannelPretty]?.filter(str => !!str)?.join(' - ');
}
